<script>
	// export let color = '#161616';
</script>

<svg
	data-svg-carbon-icon="Sun32"
	xmlns="http://www.w3.org/2000/svg"
	fill="currentColor"
	viewBox="0 0 32 32"
	><path
		d="M16 12.005a4 4 0 1 1-4 4 4.0045 4.0045 0 0 1 4-4m0-2a6 6 0 1 0 6 6 6 6 0 0 0-6-6ZM5.3943 6.813l1.4142-1.4142 3.5059 3.5058-1.4142 1.4143zM2 15.005h5v2H2zM5.3943 25.1976l3.5059-3.5058 1.4142 1.4142-3.5059 3.5059zM15 25.005h2v5h-2zM21.687 23.1053l1.4142-1.4142 3.5059 3.5058-1.4142 1.4142zM25 15.005h5v2h-5zM21.687 8.904 25.193 5.398l1.4142 1.4142-3.5059 3.5058zM15 2.005h2v5h-2z"
	/></svg
>
